module.exports = __webpack_public_path__ + "img/account.fdb5fdc4.svg";